// Represents the different states of the RBAC API request.
import { createAction, props } from '@ngrx/store';
import { RbacTokenResponse } from './rbac.state';

export const rbacLoading = createAction('[RBAC] Loading');
export const rbacLoaded = createAction('[RBAC] Loaded', props<{ response: RbacTokenResponse }>());
export const rbacFailed = createAction('[RBAC] Failed');
